var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99946 3.55029C4.22711 3.55029 3.57446 4.20294 3.57446 4.97529C3.57446 5.74764 4.22711 6.40029 4.99946 6.40029C5.77181 6.40029 6.42446 5.74764 6.42446 4.97529C6.42446 4.20294 5.77181 3.55029 4.99946 3.55029Z",
    fill: "#555555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 1.6501H7.57165L6.28582 0.364273C6.19677 0.275187 6.07597 0.225125 5.95 0.225098H4.05C3.92403 0.225125 3.80323 0.275187 3.71417 0.364273L2.42835 1.6501H1.2C0.676075 1.6501 0.25 2.07617 0.25 2.6001V7.8251C0.25 8.34902 0.676075 8.7751 1.2 8.7751H8.8C9.32393 8.7751 9.75 8.34902 9.75 7.8251V2.6001C9.75 2.07617 9.32393 1.6501 8.8 1.6501ZM5 7.3501C3.71275 7.3501 2.625 6.26235 2.625 4.9751C2.625 3.68785 3.71275 2.6001 5 2.6001C6.28725 2.6001 7.375 3.68785 7.375 4.9751C7.375 6.26235 6.28725 7.3501 5 7.3501Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCamera);
export default __webpack_public_path__ + "static/media/icn_camera.8340c7dae19825d3a0eaa2e01ee6479b.svg";
export { ForwardRef as ReactComponent };